module.exports = __webpack_public_path__ + "img/5_21.c533211f.png";